import {
    Dialog,
    DialogContent,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogActions,
    Button,
} from '@fluentui/react-components';
import React from 'react';

interface DeleteNewsDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    count: number;
}

export const DeleteNewsDialog: React.FC<DeleteNewsDialogProps> = ({
    open,
    onClose,
    onConfirm,
    count,
}) => (
    <Dialog open={open} onOpenChange={(_, data) => { if (!data.open) onClose(); }}>
    <DialogSurface>
            <DialogBody>
                <DialogTitle>News löschen</DialogTitle>
                <DialogContent>
                    Sollen die {count} ausgewählten News wirklich gelöscht werden?
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Abbrechen</Button>
                    <Button appearance="primary" onClick={onConfirm}>
                        Löschen
                    </Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>
);
